import { mapGetters } from 'vuex'

// returns if user is professinal or company
export default {
  ...mapGetters(['userIsCompany'])
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/resources/computed.js